module.exports = __webpack_public_path__ + "static/media/cancel_search.9a2e13f0.svg";